export function isStageMode() {
  return (
      document.location.hostname.split('.')[1] ===
      process.env.VUE_APP_STAGE_URL_NAME
  );
}
